import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Layout, Tabs, Button, Spin, Descriptions, Tag } from 'antd';
import { EditFilled, FormOutlined } from '@ant-design/icons';
import { get } from '../redux/actions/actividadActions';
import ActividadEditor from './ActividadEditor';
import ProduccionEditor from './ProduccionEditor';
import ActividadResumen from './ActividadResumen';
import OrdenTrabajoList from './OrdenTrabajoList';
import GastoList from './GastoList';
import ProduccionRetiroList from './ProduccionRetiroList';
import { callStatus } from '../utils/constants';
import { withRouter } from 'react-router-dom';
import { setBreadcrumbTitle } from '../redux/actions/uiActions';
import dayjs from 'dayjs';
import CustomCellRender from './base/CustomCellRender';
import { setPending as setPendingProduccion } from '../redux/actions/produccionActions';

const { Header, Content } = Layout;
const { TabPane } = Tabs;

const ActividadViewer = ({
  dispatch,
  stateData,
  match: {
    params: { id, id2 },
  },
  location,
  history,
}) => {
  const [showEdit, setShowEdit] = useState(false);
  const [showProduccion, setShowProduccion] = useState(false);

  const handleHideEditor = () => {
    setShowEdit(false);
  };

  const handleHideProduccionEditor = () => {
    setShowProduccion(false);
    dispatch(setPendingProduccion());
  };

  useEffect(() => {
    if (String(stateData.object.data?.id) !== String(id2)) {
      dispatch(get(id2));
    }
    // eslint-disable-next-line
  }, [id2, dispatch]);

  useEffect(() => {
    if (
      stateData.object.status === callStatus.OBJECT_SUCCESS ||
      stateData.object.status === callStatus.OBJECT_SAVE_SUCCESS
    ) {
      const data = stateData.object.data;
      dispatch(
        setBreadcrumbTitle(
          `/campanas/${id}/actividades/${id2}`,
          `${data.establecimiento?.nombre} / ${data.cultivo?.nombre}`
        )
      );
    }
  }, [stateData.object.status, stateData.object.data, dispatch, id, id2]);

  const getActiveKey = () => {
    if (location.pathname.includes('/ordenes-trabajo')) return '2';
    if (location.pathname.includes('/gastos')) return '3';
    if (location.pathname.includes('/retiros')) return '4';
    return '1';
  };

  const handleTabChange = (key) => {
    let path = `/campanas/${id}/actividades/${id2}`;
    if (key === '1') path += '/resumen';
    if (key === '2') path += '/ordenes-trabajo';
    if (key === '3') path += '/gastos';
    if (key === '4') path += '/retiros';
    history.replace(path);
  };

  const data = stateData.object.data;
  const loading = stateData.object.status === callStatus.OBJECT_IN_PROCESS;

  return (
    <Layout style={{ height: '100%' }}>
      <Header
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          marginTop: '5px',
          marginBottom: '10px',
          height: 'auto',
          minHeight: '50px',
          backgroundColor: 'transparent',
          padding: 0,
        }}
      >
        <Spin spinning={loading}>
          {(stateData.object.status === callStatus.OBJECT_SUCCESS ||
            stateData.object.status === callStatus.OBJECT_SAVE_SUCCESS) &&
            data &&
            data.id && (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'flex-start',
                  height: '100%',
                }}
              >
                <Descriptions
                  bordered
                  size="small"
                  column={4}
                  style={{ marginBottom: 20, flex: 1, marginRight: 20 }}
                >
                  <Descriptions.Item label="Establecimiento">
                    {data.establecimiento?.nombre}
                  </Descriptions.Item>
                  <Descriptions.Item label="Cultivo">
                    {data.cultivo?.nombre}
                  </Descriptions.Item>
                  <Descriptions.Item label="Fecha">
                    {data.fecha ? dayjs(data.fecha).format('DD/MM/YYYY') : ''}
                  </Descriptions.Item>
                  <Descriptions.Item label="Superficie Ha">
                    <CustomCellRender
                      text={data.superficie}
                      justify={'flex-start'}
                      prefix={''}
                    />
                  </Descriptions.Item>
                  <Descriptions.Item label="Aportantes" span={2}>
                    {data.inversores && data.inversores.length > 0 ? (
                      data.inversores.map((inv) => (
                        <Tag color="green" key={inv.inversor_id}>
                          {inv.inversor_nombre || inv.nombre}
                        </Tag>
                      ))
                    ) : (
                      <span>Sin Aportantes</span>
                    )}
                  </Descriptions.Item>
                  <Descriptions.Item label="Sociedad" span={2}>
                    {data.sociedad?.nombre ? (
                      <Tag color="blue">{data.sociedad.nombre}</Tag>
                    ) : (
                      <span>-</span>
                    )}
                  </Descriptions.Item>
                </Descriptions>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px',
                  }}
                >
                  <Button
                    icon={<EditFilled />}
                    onClick={() => setShowEdit(true)}
                    type="primary"
                    size="small"
                  >
                    Editar
                  </Button>
                  <Button
                    icon={<FormOutlined />}
                    onClick={() => setShowProduccion(true)}
                    type="default"
                    size="small"
                  >
                    Producción
                  </Button>
                </div>
              </div>
            )}
        </Spin>
      </Header>
      <Content>
        <Tabs
          activeKey={getActiveKey()}
          onChange={handleTabChange}
          destroyInactiveTabPane
        >
          <TabPane tab="Resumen" key="1">
            <div style={{ height: 'calc(100vh - 300px)' }}>
              <ActividadResumen />
            </div>
          </TabPane>
          <TabPane tab="Órdenes de Trabajo" key="2">
            <div style={{ height: 'calc(100vh - 300px)' }}>
              <OrdenTrabajoList />
            </div>
          </TabPane>
          <TabPane tab="Gastos" key="3">
            <div style={{ height: 'calc(100vh - 300px)' }}>
              <GastoList />
            </div>
          </TabPane>
          <TabPane tab="Retiros" key="4">
            <div style={{ height: 'calc(100vh - 300px)' }}>
              <ProduccionRetiroList />
            </div>
          </TabPane>
        </Tabs>
      </Content>
      {showEdit && (
        <ActividadEditor
          id={id2}
          parentId={id}
          onCancel={handleHideEditor}
          visible={true}
        />
      )}
      {showProduccion && (
        <ProduccionEditor
          id={null}
          parentId={id2}
          onCancel={handleHideProduccionEditor}
          visible={true}
        />
      )}
    </Layout>
  );
};

const mapStateToProps = (state) => {
  const { actividad } = state;
  const stateData = actividad;
  return {
    stateData,
  };
};

export default connect(mapStateToProps)(withRouter(ActividadViewer));
